<template>
    <div class="chatbot-page chatbot-assessment-share-page">

        <div class="chatbot-page-header hidden-xs-only">
            <header-bar></header-bar>
        </div>

        <div class="chatbot-page-content-wrapper"><!-- Wrapper for the whole page content, excepting the header. -->

            <div class="chatbot-page-content animate-hide-answer-list"><!-- Whole page content (excepting the header) -->

                <v-layout row wrap class="assessment-share-page">

                    <v-flex xs12 align-start class="padding-bottom-xs padding-top-s share-section-title" >
                        <div class="title-icon-share-page">
                            <div class="title-share-page-icon" @click="goToPreviousPage()">
                                <arrow-back-icon />
                            </div>
                            <h2 class="page-title accessibility-spacing-medium" >{{text("api.share.page.title")}}</h2>
                        </div>
                    </v-flex>

                    <v-flex xs12 sm12 class="no-padding">
                        <v-card class="assessment-share-page-btns" v-if="getSummaryDataNew">
                            <v-card-text>
                                <div>
                                    <h5 class="chatbot-share-headline">
                                        {{text("api.share.page.assessment.data.headline")}}
                                    </h5>
                                    <span>{{getSummaryDataNew.assessmentToken}} - {{getSummaryDataNew.assessmentDateNew}} {{getSummaryDataNew.assessmentTimeNew}}</span>
                                </div>
                                <div>
                                    <h5 class="chatbot-share-headline">
                                        {{text("api.share.page.main.symptom.headline")}}
                                    </h5>
                                    <span>{{getSummaryDataNew.mainSymptom}}</span>
                                </div>
                                <div v-if="getSummaryDataNew.relatedSymptomList">
                                    <h5 class="chatbot-share-headline">
                                        {{text("api.share.page.related.symptoms.headline")}}
                                    </h5>
                                    <span v-for="relatedSymptom in getSummaryDataNew.relatedSymptomList">{{relatedSymptom}}<br /></span>
                                </div>
                                <div>
                                    <h5 class="chatbot-share-headline">
                                        {{text("api.assessment.headline.di1")}}
                                    </h5>
                                    <span>{{getSummaryDataNew.decisionItem1}}</span>
                                </div>
                                <div v-if="getSummaryDataNew.decisionItem2 != null">
                                    <h5 class="chatbot-share-headline" >
                                        {{text("api.assessment.headline.di2")}}
                                    </h5>
                                    <span style="display: inline-flex" class="share-page-target">
                                            <span v-if="getSummaryDataNew.target === true">
                                                <WarningIcon></WarningIcon>
                                            </span>
                                             <span>{{getSummaryDataNew.decisionItem2}}</span>
                                    </span>
                                </div>

                                <div class="share-btns">
                                    <!-- PDF -->
                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('PDF') > -1"
                                         @click="printPdfTemplate()"
                                         class="share-icon">
                                        <pdf-icon-svg></pdf-icon-svg>
                                    </div>

                                    <!-- EMAIL -->
                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('EMAIL') > -1"
                                         @click="sendEmail()"
                                         class="share-icon">
                                        <email-icon-svg v-bind:class="{borderRed: mustShowSendAssessmentPopup}"></email-icon-svg>
                                    </div>

                                    <!-- TRANSLATE -->
                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('TRANSLATE') > -1"
                                         @click="showTranslatePdfPopup()"
                                         class="share-icon">
                                        <translate-pdf-icon :class="{borderRed: mustShowTranslatePdfPopup}"></translate-pdf-icon>
                                    </div>

                                    <!-- THREEMA -->
                                    <div v-if="getAppPropertyValueArray('SHARING_CHANNELS', {mustUppercaseAll: true}).indexOf('THREEMA') > -1"
                                         @click="showPdfMessagePopup()"
                                         class="share-icon">
                                        <threema-icon-svg :class="{borderRed: mustShowSendPdfMessagePopup}"></threema-icon-svg>
                                    </div>

                                </div>
                            </v-card-text>

                                <v-card-actions>
                                    <v-btn @click="goToHomePage"
                                           v-if="!getUserData.embedded && getVoucherData === null"
                                           flat
                                           round
                                           block
                                           color="primary"
                                           class="footer-btn home btn-share-send-assessment text-transform-none"
                                           style="font-weight: 400;">
                                        {{text("api.chatbot.btn.startNewAssessment")}}
                                    </v-btn>
                                </v-card-actions>
                        </v-card>
                    </v-flex>

                </v-layout>

            </div>
        </div>



        <!-- Begin SEND EMAIL FORM -->
        <v-dialog v-model="mustShowSendAssessmentPopup"
                  scrollable
                  max-width="600"
                  persistent
                  transition="dialog-bottom-transition"
                  content-class="dialog-chatbot--share-assessment--send-email-popup">

            <v-card
                class="assessment-share-page-btn-action sendAssessment component-bg-color">

                <v-card-title style="justify-content: center; max-height: 55px;">
                        <span  @click="closeSendEmailPopup" class="float-left cursor-pointer" style="position: absolute;left: 15px; top: 15px;">

                            <close-icon :svg-fill-class="'svg-secondary-color'"/>

                        </span>
                    <span class="font-weight-bold">{{text("api.share.page.send.email.title")}}</span>
                </v-card-title>

                <v-card-text>
                    <v-form v-model="valid" ref="form" class="margin-top-l" style="min-height: 250px;">
                        <v-flex xs12 sm12 class="no-padding-left">
                            <label>{{text('api.summary.communication.summary.mail')}}</label>
                            <v-text-field
                                v-model="email"
                                solo
                                :placeholder="'@example.com'"
                                :rules="emailRules"
                                clearable
                                ref="EMAIL_FIELD"
                                class="field-email-address"
                            ></v-text-field>
                            <br />
                            <v-checkbox v-if="getAppType !== 'PF_CHATBOT_PUBLIC'"
                                        ref="CHECKBOX_COPY_FIELD"
                                        v-model="checkbox"
                                        :label="text('api.summary.communication.summary.link')"
                                        color="primary">
                            </v-checkbox>
                            <p v-if="sentFlag" class="successfulSent">{{ text('api.scoring.send.popup.text') }}</p>
                        </v-flex>
                    </v-form>
                </v-card-text>

                <v-card-actions class="share-page-buttons">

                    <v-btn v-if="!sentFlag"
                           @click="sendAssessment(), setSentFlagFalse()"
                           :disabled="valid === false"
                           :class="{'color-primary' : valid === true }"
                           >
                        {{text('api.button.send')}}
                    </v-btn>

                    <v-btn v-if="!sentFlag && getVoucherData === null"
                           @click="sendAssessmentPushHome()"
                           :disabled="valid === false"
                           :class="{'color-primary' : valid === true }">
                        {{text('api.button.send.and.start')}}
                    </v-btn>

                </v-card-actions>
            </v-card>

        </v-dialog>
        <!-- End SEND EMAIL FORM -->

        <pdf-message-form-popup
            :is-popup-open="mustShowSendPdfMessagePopup"
            :assessment-token="getAssessmentToken"
            :assessment-version="getAssessmentVersion"
            @onClosePopup="hidePdfMessagePopup"
        ></pdf-message-form-popup>

        <pdf-template-selection-popup
            :is-popup-open="isPdfTemplateListActive"
            @onSelectPdfTemplate="handlePdfTemplateSelected"
            @onClosePopup="hidePdfTemplateSelectionPopup"
        ></pdf-template-selection-popup>

        <translate-pdf-popup
            :is-popup-open="mustShowTranslatePdfPopup"
            @onDownloadPdf="startPrintPdf($event.pdfTemplate, $event.languageKey)"
            @onClosePopup="hideTranslatePdfPopup"
        ></translate-pdf-popup>

        <code-popup></code-popup>
        <div class="cookies-display">
            <detect-browser-cookie></detect-browser-cookie>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapActions, mapGetters} from 'vuex';
import HeaderBar from '../shared/HeaderBar';
import CodePopup from '../../../common/components/shared/ActivationCodePopup';
import PdfTemplateSelectionPopup from "./PdfTemplateSelectionPopup";
import DetectBrowserCookie from '../../../common/components/cookies/DetectBrowserCookie';
import Vue from "vue"; // need this to use the plugin methods
import pdfIconSvg from "../../../common/components/svg/shared/pdfIcon";
import emailIconSvg from "../../../common/components/svg/shared/emailIcon";
import translatePdfIcon from "../../../common/components/svg/shared/translatePdfIcon";
import TranslatePdfPopup from "./TranslatePdfPopup";

import axios from "axios";
import ArrowBackIcon from "../../../common/components/svg/shared/arrowBackIcon";
import CloseIcon from "../../../common/components/svg/shared/closeIcon";
import threemaIconSvg from "../../../common/components/svg/shared/threemaIcon";
import PdfMessageFormPopup from "./PdfMessageFormPopup";
import WarningIcon from "../../../common/components/svg/shared/warningIcon.vue";

const CLASS_CHATBOT_ROOT = "root-pf-chatbot"; // This class will be added on <html> tag when current route is pointing to this component.
const CLASS_CHATBOT_ASSESSMENT_SHARE_ROOT = "root-pf-chatbot--assessment-share"; // This class will be added too on <html> tag when current route is pointing to this component.

    export default {
        name: 'ChatbotAssessmentSharePage',
        components: {
            WarningIcon,
            CloseIcon,
            ArrowBackIcon,
            HeaderBar,
            CodePopup,
            PdfTemplateSelectionPopup,
            // AcceptCookie,
            DetectBrowserCookie,
            pdfIconSvg,
            emailIconSvg,
            translatePdfIcon,
            threemaIconSvg,
            TranslatePdfPopup,
            PdfMessageFormPopup,
        },

        data () {
            return {
                valid: false,
                email: '',
                checkbox: false,
                items: [
                    {
                        src: 'static/img/in4medicine_logo.svg',
                        title: 'in4medicine',
                        description: 'Medizin und Informatik - ein starkes Team.'
                    }
                ],
                emailRules: [
                    (value) => (value || "").length > 0 || this.text("api.error.field.required"),
                    (value) => {
                        let regex = /^(([a-zA-Z0-9_\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-.]+)@((\[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df\-]+\.)+))([a-zA-Z\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]{2,15}|[0-9]{1,3})(]?)(\s*\040\s*|\s*$))*$/;
                        return regex.test(value) || this.text("api.error.email.invalid");
                    }
                ],
                sentFlag: false,
                // isActive: false,
                mustShowSendAssessmentPopup: false,
                mustShowSendPdfMessagePopup: false,
                isPdfTemplateListActive: false,
                mustShowTranslatePdfPopup: false,
                checkBoxPlugin: Vue.CheckBox.checkBoxSvg
            }
        },


        created () {

            if (this.getAssessmentToken !== null) {
                this.$store.dispatch('AssessmentShareStore/loadAssessmentData', {
                    assessmentToken: this.getAssessmentToken,
                    assessmentVersion: 1 // "3" // @TODO TEMPORARY HARDCODED! What value should we pass here???
                });
            }
        },

        mounted() {
            // Add chatbot identifier class on body element.
            let htmlElem = document.querySelector('html');
            htmlElem.classList.add(CLASS_CHATBOT_ROOT);
            htmlElem.classList.add(CLASS_CHATBOT_ASSESSMENT_SHARE_ROOT);
        },
        destroyed() {
            // Remove chatbot identifier class from body element.
            let htmlElem = document.querySelector('html');
            if (htmlElem.classList.contains(CLASS_CHATBOT_ROOT)) {
                htmlElem.classList.remove(CLASS_CHATBOT_ROOT);
            }
            if (htmlElem.classList.contains(CLASS_CHATBOT_ASSESSMENT_SHARE_ROOT)) {
                htmlElem.classList.remove(CLASS_CHATBOT_ASSESSMENT_SHARE_ROOT);
            }
        },

        computed: {
            ...mapGetters({
                // getAssessmentToken: 'ChatBotStore/getAssessmentToken',

                getUserData: 'UserStore/getUserData',
                // getMustShowAssessmentList: 'SymptomsQuestionsStore/getMustShowAssessmentList',
                // sentFlag: 'ScoringStore/getAssessmentSent',
                // getIsAssessmentSealed: 'ScoringStore/getIsAssessmentSealed',
                getSummaryDataNew: 'AssessmentShareStore/getSummaryDataNew',
                getVoucherData: 'TranslationStore/getVoucherData',
                // mustShowSendAssessmentPopup: 'ScoringStore/getMustShowSendAssessmentPopup',
                getAppType: 'TranslationStore/getAppTypeName',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getAppPropertyValueArray: 'TranslationStore/getAppPropertyValueArray',
            }),
            currentRouteName() {
                return this.$route.name;
            },
            getAssessmentToken() {
                return sessionStorage.getItem('pfiAssessmentToken');
            },
            getAssessmentVersion() {
                return sessionStorage.getItem('pfiAssessmentVersion');
            },
            getPdfTemplateList() {
                return this.getAppPropertyValueArray('PDF_TEMPLATE');
            },
        },

        methods: {
            ...mapActions({
                showActivationCodePopup: 'ProductListStore/showActivationCodePopup',
                showSendAssessmentPopup: 'ScoringStore/showSendAssessmentPopup',
            }),

            hideTestPopup() {
                this.$store.commit('ProductListStore/setMustShowActivationCodePopup', false);
            },

            printPdfTemplate() {

                if (this.getAppPropertyValueArray('PDF_TEMPLATE').length === 0) {
                    this.startPrintPdf();
                }
                else if (this.getAppPropertyValueArray('PDF_TEMPLATE').length === 1) {
                    this.startPrintPdf(this.getAppPropertyValueArray('PDF_TEMPLATE')[0]);
                }
                else if (this.getAppPropertyValueArray('PDF_TEMPLATE').length > 1) {
                    this.showPdfTemplateSelectionPopup();
                }
            },

            showPdfTemplateSelectionPopup() {
                this.mustShowSendAssessmentPopup = false;
                this.mustShowTranslatePdfPopup = false;
                this.isPdfTemplateListActive = true;
                this.mustShowSendPdfMessagePopup = false;
            },
            hidePdfTemplateSelectionPopup() {
                this.isPdfTemplateListActive = false;
            },
            handlePdfTemplateSelected(pdfTemplate) {
                this.startPrintPdf(pdfTemplate);
                this.hidePdfTemplateSelectionPopup();
            },

            showTranslatePdfPopup() {
                this.isPdfTemplateListActive = false;
                this.mustShowSendAssessmentPopup = false;
                this.mustShowTranslatePdfPopup = true;
                this.mustShowSendPdfMessagePopup = false;
            },
            hideTranslatePdfPopup() {
                this.mustShowTranslatePdfPopup = false;
            },
            showPdfMessagePopup() {
                this.isPdfTemplateListActive = false;
                this.mustShowSendAssessmentPopup = false;
                this.mustShowTranslatePdfPopup = false;
                this.mustShowSendPdfMessagePopup = true;
            },
            hidePdfMessagePopup() {
                this.mustShowSendPdfMessagePopup = false;
            },

            /**
             * Immediately download a PDF file containing the assessment data.
             * @param pdfTemplate {String} (optional)
             * @param languageKey {String} (optional) - Language. Used for PDF translation.
             */
            startPrintPdf(pdfTemplate, languageKey){

                if (typeof pdfTemplate !== 'string') {
                    pdfTemplate = ''; // If no template name is passed, the API will use the default template.
                }

                let requestParams = {
                    assessmentToken: null,
                    assessmentVersion: null,
                    template: pdfTemplate,
                    decisionItem1Label: null,
                    decisionItem1Color: null,
                    decisionItem2Label: null,
                    decisionItem2Icon: null,
                    decisionText: "",
                    disclaimer1: "",
                    disclaimer2: ""

                };

                if (typeof this.$route.query.assessmentId !== "undefined") {
                    requestParams.assessmentToken   = this.getAssessmentToken;
                    requestParams.assessmentVersion = this.getAssessmentVersion;
                }
                else if (this.$route.query.assessment) {
                    requestParams.assessmentToken   = this.$route.query.assessment;
                    requestParams.assessmentVersion = this.getAssessmentVersion;
                }
                else {
                    requestParams.assessmentToken   = null;
                    requestParams.assessmentVersion = null;
                }

                if (typeof languageKey === "string" && languageKey.length > 0) {
                    requestParams.translationLanguage = languageKey;
                }

                let axiosRequest = axios.post(
                    process.env.API_BASE_URL_PATHFINDER + '/assessment/deliverPDF',
                    requestParams,
                    {
                        responseType: 'arraybuffer',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/pdf'
                        }
                    }
                );

                axiosRequest.then((response) => {

                    const attachment_name = response.headers["attachement-file-name"];

                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(new Blob([response.data]), decodeURIComponent(attachment_name)); /* IE browser Solution*/
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        if (attachment_name == null || attachment_name === ""){
                            link.setAttribute('download', "assessment_case.pdf"); //or any other extension
                        }else{
                            link.setAttribute('download', decodeURIComponent(attachment_name)); //or any other extension
                        }

                        document.body.appendChild(link);
                        link.click();
                    }
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            setSentFlag(){
                this.sentFlag = true;
            },

            setSentFlagFalse(){
                let that = this;
                setTimeout(function(){
                    that.sentFlag = false;
                }, 2300);
            },

            sendAssessment() {
                this.$refs.form.validate();

                let requestParams = {
                    email: this.email,
                    sendEmailToUser: this.checkbox,
                    assessmentToken: this.getAssessmentToken,
                    assessmentVersion: this.getAssessmentVersion
                };

                let axiosRequest = axios.post(process.env.API_BASE_URL + '/assessment/sendAssessmentEmail', requestParams);

                axiosRequest.then((response) => {
                    console.log("accept data");
                    console.log(response);

                    this.$store.commit('ScoringStore/setIsAssessmentSealed', true);

                    this.setSentFlag()
                });
                axiosRequest.catch((error) => {
                    console.log(error);
                });
            },

            closeSendEmailPopup() {
                this.mustShowSendAssessmentPopup = false;
            },

            sendAssessmentPushHome() {
                this.sendAssessment()
                let that = this;
                setTimeout(function() {
                    that.goToHomePage();
                }, 500);

            },
            sendEmail: function() {
                this.isPdfTemplateListActive = false;
                this.mustShowTranslatePdfPopup = false;
                this.mustShowSendAssessmentPopup = true;
            },

            goToPreviousPage() {
                this.$router.push('/pathfinder/chatbot-scoring');
            },

            goToHomePage() {
                this.$router.push({name: 'PF_ChatBotPage'}).then(() => { // Go to Chatbot's home page (product list).
                    sessionStorage.removeItem("crtChatbotSection");
                    window.location.reload();
                });
            }

        },
        watch: {
            checkbox(newValue, oldValue) {
                if(newValue === true) {
                    let that = this;
                    setTimeout(function () {
                        let noOtherSymptom = document.getElementsByClassName('dialog-chatbot--share-assessment--send-email-popup');
                        for (let i = 0; i < noOtherSymptom.length; i++) {
                            let iconCheckBox = noOtherSymptom[i].getElementsByClassName('icon--checkbox');

                            for (let j = 0; j < iconCheckBox.length; j++) {
                                iconCheckBox[j].innerHTML = that.checkBoxPlugin();
                            }
                        }

                    }, 10)
                }
            }
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

  /*  .home-container.container.grid-list-xl {
        .body-home {
            margin-bottom: -60px;

            .product_icon {
                width: 30px;
            }
        }
    }

    .product-list {
        li, .product-item {
            border-radius: 5px;
        }
    }

    .container.grid-list-xl .activate-product{
        button {
            text-transform: none;
            @include border-radius(4px);

        }
    }

    .btn-start-assessment {
        border-color: $color-lines;
    }

    .icon-start-assessment {
        font-size: 36px;
    }

    .sponsors {
        border-radius: 5px;
    }


    .dialog-chatbot--share-assessment--send-email-popup .card__actions button.btn {
        border-radius: 23px;
        padding-left: 24px;
        padding-right: 24px;
        border: 1px solid #e0e0e0 !important;
    }
    .dialog-chatbot--share-assessment--send-email-popup .card__actions button.btn:not(.btn--disabled) {
        background-color: #fff !important;
      //  color: #a43a45;
    }*/

</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/ChatbotAssessmentSharePage.vue